import { decodeHtmlEntities } from "./html";

type ProductSeoFields = {
	Title?: string | null;
	MetaTags?: string | null;
	VariantName?: string | null;
	Name?: string | null;
};

type ProductCandidate = ProductSeoFields | null | undefined;

// Entities only, not tags: a title like "Adapter <EF-mount>" stays intact.
const firstFilled = (values: (string | null | undefined)[]): string =>
	values
		.map(
			(value) => value && decodeHtmlEntities(value).replace(/\s+/g, " ").trim()
		)
		.find(Boolean) || "";

/** The Norce SEO title ("Title" in admin) alone; empty when none is set. */
export const buildProductSeoTitle = (...products: ProductCandidate[]): string =>
	firstFilled(products.map((candidate) => candidate?.Title));

/**
 * PDP `<title>`: the Norce SEO title from the first candidate that has one,
 * else the first candidate's name.
 */
export const buildProductMetaTitle = (
	...products: ProductCandidate[]
): string => {
	const product = products.find(Boolean);
	return (
		buildProductSeoTitle(...products) ||
		firstFilled([product?.VariantName, product?.Name])
	);
};

/** PDP meta keywords: the Norce "Meta keywords" field (`MetaTags`). */
export const buildProductMetaKeywords = (
	...products: ProductCandidate[]
): string => firstFilled(products.map((candidate) => candidate?.MetaTags));
